require('@/patternfly.js');
import 'guaxinim-web/dist/guaxinim-web.css';
import '@/global-css.scss';
import '../../../node_modules/font-awesome/css/font-awesome.min.css';
import '@/registerServiceWorker';

import Vue from 'vue';
import GuaxinimWeb from 'guaxinim-web';
import App from '@/App';
import i18n from '@/i18n';
import A7WebCustomExceptionHandler from '@/js/A7WebCustomExceptionHandler';
import router from './router';
import menu from './router/menu';
import Http from '@/js/Http';

Vue.config.productionTip = true;

Vue.use(GuaxinimWeb, {
  customExceptionHandlers: [A7WebCustomExceptionHandler]
});

Vue.prototype.$menu = menu;

Http.currentSite = 'public';

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app');
